/**
 * App registry: loads manifest and provides dynamic imports for modules.
 * Pseudocode:
 * - Import manifest.json (static)
 * - Validate shape (lightweight runtime checks)
 * - Use Vite glob imports to map id -> component loader
 */
import manifest from './manifest.json';

export type AppEntry = {
  id: string;
  name: string;
  description: string;
  icon?: string;
  route: string;
  tags?: string[];
  flags?: Record<string, unknown>;
};

// Basic validation to prevent runtime surprises
function isValid(entry: any): entry is AppEntry {
  return (
    entry &&
    typeof entry.id === 'string' &&
    typeof entry.name === 'string' &&
    typeof entry.description === 'string' &&
    typeof entry.route === 'string'
  );
}

export const apps: AppEntry[] = (manifest as any[]).filter(isValid);

// Vite glob imports for Svelte components located at ./<id>/index.svelte
const modules = import.meta.glob('./*/index.svelte');

export function loadAppComponent(id: string) {
  // Lookup dynamic import function by folder path
  const key = `./${id}/index.svelte`;
  const loader = (modules as Record<string, () => Promise<unknown>>)[key];
  if (!loader) throw new Error(`App component not found for id: ${id}`);
  return loader;
}

